import React from "react";
import styles from "./AnswerDotsPanel.module.css";

import CircleBlack from "../../images/circle-answer-black.png";
import CircleGreen from "../../images/circle-answer-green.png";
import CircleRed from "../../images/circle-answer-red.png";

import gameConfig from "../../gameConfig";

function PlayerScore({ answers = [] }) {
  const items = [];

  for (let i = 0; i < gameConfig.answersCount; i++) {
    if (i < answers.length) {
      items.push(answers[i]);
    } else {
      items.push({
        status: null,
      });
    }
  }

  return (
    <div className={styles.wrapper}>
      {items &&
        items.length &&
        items.map((item, index) => {
          let image;
          switch (item.status) {
            case true:
              image = CircleGreen;
              break;
            case false:
              image = CircleRed;
              break;
            default:
              image = CircleBlack;
          }

          return (
            <img
              src={image}
              alt="answer dot"
              className={styles.dot}
              key={index}
            />
          );
        })}
    </div>
  );
}

export default React.memo(PlayerScore);
